import { render, staticRenderFns } from "./PaymentTransactionsGivenNewForm.vue?vue&type=template&id=7b7e812c"
import script from "./PaymentTransactionsGivenNewForm.vue?vue&type=script&lang=js"
export * from "./PaymentTransactionsGivenNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports